// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","130":"243ff63c","137":"47f9a896","349":"763b450e","483":"623577a1","892":"72b8f9bc","899":"7715c8ec","950":"37a6255e"}[chunkId] + ".chunk.js";
};